<template>
  <div class="container-fluid">
    <b-overlay :show="showOverlay" rounded="sm">
      <b-col class="container text-right"> </b-col>

      <b-card class="mt-2 col-12">
        <b-col class="container text-right">
          <!-- <b-button variant="primary" class="mb-2 mr-sm-2" @click="onBtnAddClicked">
            <feather-icon icon="PlusIcon" class="mr-25" />
            <span>เพิ่มข้อมูล</span>
          </b-button> -->
          <b-button
            variant="info"
            class="mb-2 mr-sm-2"
            @click="onBtnAddComplaintGroupClicked"
          >
            <feather-icon icon="PlusIcon" class="mr-25" />
            <span>จัดกลุ่มร้องทุกข์</span>
          </b-button>
        </b-col>
        <b-tabs>
          <b-tab
            v-for="tab in tabs"
            :key="tab.title"
            :title="tab.title"
            lazy
            @click.prevent="setActiveTabName(tab.mode, tab.header)"
          >
            <b-col cols="12">
              <SearchFilter
                ref="searchFilter"
                :mode="tab.mode"
                @handleSubmit="searchFilterSubmit"
              />
            </b-col>
          </b-tab>
        </b-tabs>
      </b-card>

      <b-card v-for="tab in activeTab" :id="tab" :key="tab">
        <commonTable
          ref="tableCommon"
          :routeName="$route.name"
          :tableHeader="tableHeader"
          :searchMode="tab"
          @handleGroup="getManage"
          @handleOverlay="setOverlay"
        >
          <b-tabs
            v-if="tabs.find((value) => value.mode === tab).subTabs.length > 0"
          >
            <b-tab
              v-for="subTab in tabs.find((value) => value.mode === tab).subTabs"
              :key="subTab.title"
              :title="subTab.title"
              lazy
              @click.prevent="
                setActiveTabSubName(
                  tabs.find((value) => value.mode === tab),
                  subTab.mode
                )
              "
            >
            </b-tab>
          </b-tabs>
        </commonTable>
      </b-card>
    </b-overlay>

    <ModalNotification
      ref="ModalNotification"
      :complaints="notificationComplaints"
    />

    <ModalComplaintGroup
      ref="ModalComplaintGroup"
      modeGrp="Officer"
      :isInGroup="false"
      :complaintGroupId="null"
      :complaintGroupCode="null"
      :complaintGroupIssue="null"
    />
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BTabs,
  BTab,
  BButton,
  BCard,
  BCardHeader,
  BCardBody,
  BOverlay,
} from "bootstrap-vue";
import commonTable from "@/views/Complaint/components/vueGoodTable/commonTable.vue";
import commonTableHeader from "@/views/Complaint/components/vueGoodTable/commonTableHeaderWithFastTrack.js";
import SearchFilter from "@/views/Complaint/components/vueGoodTable/SearchFilter.vue";

import ModalNotification from "./components/ModalNotification.vue";
import commonTable2 from "../../table/vue-good-table/commonTableModal.vue";
import * as officerStore from "@/store/api/officer/index.js";
import * as userData from "@/auth/localStorageUtils.js";

import commonTableGroupHeader from "@/views/Complaint/components/vueGoodTable/commonTableGroupHeader.js";
import ModalComplaintGroup from "@/views/Complaint/components/ComplaintGroup/components/ModalComplaintGroup.vue";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    BCard,
    BCardHeader,
    BCardBody,
    BOverlay,
    commonTable,
    commonTable2,
    SearchFilter,
    ModalNotification,
    ModalComplaintGroup,
  },
  data() {
    return {
      tabs: [
        {
          title: "รายการเรื่องร้องทุกข์",
          mode: "Officer",
          header: commonTableHeader,
          activeTab: ["All"],
          subTabs: [
            { title: "แสดงทั้งหมด", mode: "All" },
            { title: "รอเอกสารเพิ่มเติม", mode: "WaitDoc" },
            { title: "แบบฟอร์มรอดำเนินการ", mode: "WaitDocApprove" },
            { title: "ผู้ร้องยุติเรื่อง", mode: "Cancel" },
            { title: "FastTrack", mode: "FastTrack" },
          ],
        },
        {
          title: "การดำเนินการแบบเป็นกลุ่ม",
          mode: "UserGroup",
          header: commonTableGroupHeader,
          activeTab: [],
          subTabs: [
            { title: "ดำเนินการ", mode: "All" },
            { title: "ประวัติ", mode: "OfficerGroupHistory" },
          ],
        },
        {
          title: "ประวัติดำเนินการ",
          mode: "UserHistory",
          header: commonTableHeader,
          activeTab: [],
          subTabs: [],
        },
      ],
      activeTab: ["Officer"],
      tableHeader: commonTableHeader,
      modalName: "my-modal",
      notificationComplaints: [],
      showOverlay: false,
    };
  },
  created() {
    //this.getComplaintNotification();
  },
  beforeMount() {
    //this.$modals.show(this.modalName);
  },
  methods: {
    setOverlay(isShow) {
      this.showOverlay = isShow;
    },
    onBtnAddComplaintGroupClicked() {
      this.$refs.ModalComplaintGroup.$refs["modal-add-complaint-group"].show();
    },
    getComplaintNotification() {
      const _this = this;
      officerStore
        .getComplaintForNoti(userData.departmentId(), userData.userId())
        .then((response) => {
          console.log("data", response.data.data);
          if (response.data.data.totalresult > 0) {
            // show data
            _this.notificationComplaints = response.data.data.listForNewcase;

            _this.$refs.ModalNotification.$refs["modal-notification"].show();
          }
          //_this.$refs.ModalNotification.$refs["modal-notification"].show();
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    setActiveTabName(name, header) {
      this.activeTab = [];
      this.activeTab.push(name);
      this.tableHeader = header;
    },
    setActiveTabSubName(tab, mode) {
      tab.activeTab = [];
      tab.activeTab.push(mode);
      this.$refs.searchFilter[0].onSearchBtnClicked();
    },
    getActiveTabSubName() {
      try {
        const _this = this;
        const activeTab = _this.tabs.find(
          (value) => value.mode === _this.activeTab[0]
        );
        if (activeTab.activeTab !== null && activeTab.activeTab !== undefined) {
          if (activeTab.activeTab.length > 0) {
            return activeTab.activeTab[0];
          }
        }

        return null;
      } catch (ex) {
        console.log("getActiveTabSubName ex", ex);
        return null;
      }
    },
    showCancelTab() {
      if (this.activeTab !== undefined) {
        if (this.activeTab === "List") {
          if (this.tab.activeTab[0] !== undefined) {
            if (this.tab.activeTab.length > 0) {
              if (this.tab.activeTab[0] === "Cancel") {
                return true;
              }
            }
          }
        }
      }

      return false;
    },
    getManage(id, isGroup) {
      // let routeData = this.$router.resolve({name: 'LawGroupdManage' });
      // window.open(routeData.href, '_blank');
      if (this.activeTab[0] == "UserHistory") {
        if (isGroup === true) {
          this.getManageGroup(id);
        } else {
          const routeData = this.$router.resolve({
            name: "ComplaintHistoryDetail",
            query: { id },
          });
          window.open(routeData.href, "_blank");
        }
      } else if (this.activeTab[0] == "UserGroup") {
        this.getManageGroup(id);
      } else {
        if (isGroup === true) {
          this.getManageGroup(id);
        } else {
          const routeData = this.$router.resolve({
            name: "OfficerManage",
            query: { id },
          });
          window.open(routeData.href, "_blank");
        }
      }
    },
    getManageGroup(id) {
      const routeData = this.$router.resolve({
        name: "OfficerGroupManage",
        query: { id },
      });
      window.open(routeData.href, "_blank");
    },
    onBtnClosePopup() {
      if (this.$modals.isActive(this.modalName) === true)
        this.$modals.hide(this.modalName);
    },
    onBtnReceive() {
      if (this.$modals.isActive(this.modalName) === true)
        this.$modals.hide(this.modalName);
    },
    searchFilterSubmit(params) {
      params.departmentId = userData.departmentId();
      params.userActive =
        this.$route.query.id == null ? userData.userId() : this.$route.query.id;

      // false : เรื่องที่ยังไม่ได้เอาเข้ากลุ่ม / true : เรื่องที่เอาเข้ากลุ่มแล้ว
      params.isInGroup = false;
      // เก็บชื่อ Tab ตามการที่กด
      params.tabName = this.getActiveTabSubName();
      // Tabs ย่อยของ ดำเนินการแบบเป็นกลุ่ม => ดำเนินการ [All]  / ประวัติ [GroupHistory]
      params.closeJob = params.tabName === "OfficerGroupHistory" ? true : false;
      this.updateFastTrackTab(params, "SearchFilter");
      this.$refs.tableCommon[0].onSearchSubmit(params);
    },
    updateFastTrackTab(
      params,
      mainTabMode = "Officer",
      subTabMode = "FastTrack",
      page = 1,
      perPage = 1,
      source = "search"
    ) {
      // console.group(`Search Triggered (${source})`);
      // console.log("Active Tab:", this.activeTab[0]);
      // console.log("Active Sub Tab:", this.getActiveTabSubName());
      // console.log("Params:", JSON.parse(JSON.stringify(params)));
      // console.groupEnd();
      if (params.tabName === "All" || params.tabName == subTabMode) {
        const searchParams = {
          ...params,
          tabName: subTabMode,
          page,
          perPage,
        };

        officerStore.getComplaintForUser(searchParams).then((response) => {
          console.log("response fasttrack", response);
          let fastTrackCount = 0;
          if (
            response.data.success &&
            response.data.data != null &&
            response.data.data.length > 0
          ) {
            fastTrackCount = response.data.data[0].fastTrackWorkableCount ?? 0;
          }

          const mainTab = this.tabs.find((t) => t.mode === "Officer");
          if (!mainTab) return;

          mainTab.subTabs = mainTab.subTabs.map((st) =>
            st.mode === subTabMode
              ? { ...st, title: `${subTabMode} (${fastTrackCount})` }
              : st
          );
        });
      }
    },
    onBtnAddClicked() {
      window.open(
        this.$router.resolve({
          name: "servicecentercomplaint",
          query: { parentComponent: "Officer" },
        }).href,
        "_self"
      );
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
